import { primaryColor, defaultFont, whiteColor, blackColors, hexToRgb } from 'assets/jss/material-dashboard-pro-react';

const icon = {
	'& svg': {
		position: 'relative',
		marginRight: 2,
		top: 3,
		height: 16,
		width: 16,
		color: blackColors[4],
	},
};

const additionalInfoStyle = (theme) => ({
	dialogBody: {
		borderTop: `1px solid ${blackColors[6]}`,
		paddingTop: 8,
	},
	topUpDialogValue: {
		marginTop: 18,
		marginBottom: 22,
		lineHeight: '40px',
		fontFamily: theme.fontFamily.alvar.bold,
		'& > p': {
			display: 'inline-block',
			marginBottom: 0,
		},
		'& > p:first-child': {
			fontSize: '34px',
		},
		'& > p:nth-child(2)': {
			fontSize: '23px',
			marginLeft: 5,
		},
	},
	payAgainButton: {
		width: '100%',
	},
	seePayments: {
		whiteSpace: 'pre-line',
	},
	error: {
		color: '#d41565!important',
	},
	monthCvvContainer: {
		display: 'flex',
		'& > div': {
			width: '100%',
		},
		'& > div:nth-child(odd)': {
			marginRight: 8,
		},
		'& > div:nth-child(even)': {
			marginLeft: 8,
		},
	},
	cardBrand: {
		position: 'absolute',
		top: 27,
		left: -29,
		height: 24,
		width: 24,
	},
	billingAddress: {
		marginTop: 30,
		marginBottom: 0,
	},
	noPadding: {
		paddingTop: 10,
	},
	formContainer: {
		padding: '60px 124px 0',
		[theme.breakpoints.down('sm')]: {
			padding: '60px 20px 60px 30px',
		},
	},
	formSummary: {
		display: 'flex',
		'& > div': {
			width: '100%',
		},
		'& > div:nth-child(even)': {
			textAlign: 'right',
		},
	},
	formSummaryCaption: {
		marginTop: 12,
		lineHeight: theme.direction === 'rtl' ? '1.2 !important' : 'normal',
	},
	editValue: {
		width: '200px',
		height: '152px',
		borderRadius: 4,
		position: 'absolute',
		top: -16,
		right: 10,
		overflow: 'unset',
		zIndex: 1200,
	},
	selectedItem: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		'& p': {
			marginBottom: 0,
			lineHeight: theme.direction === 'rtl' ? 1 : 'normal',
		},
		'& svg': {
			color: blackColors[4],
			width: '24px',
			height: '24px',
			marginRight: '8px',
		},
	},
	selectedItemIcon: {
		height: 24,
		width: 24,
		marginRight: 8,
	},
	tableDepartments: {
		'& .rt-td': {
			paddingTop: 4,
			paddingBottom: 4,
			margin: 'auto 0',
			minHeight: 40,
			display: 'flex',
		},
		'& .rt-td:last-of-type, & .rt-th:last-of-type': {
			textAlign: 'left',
		},
	},
	tableNumbers: {
		'& .rt-td': {
			paddingTop: 10,
			paddingBottom: 8,
			maxHeight: 40,
			minHeight: 40,
			height: 40,
		},
		'& .rt-td, & .rt-th': {
			textAlign: 'left !important',
		},
	},
	auto: {
		margin: 'auto 0',
	},
	numbersPhone: {
		height: 16,
		width: 16,
		color: blackColors[4],
		marginRight: 8,
		position: 'relative',
		top: 3,
	},
	phone: {
		...icon,
	},
	phoneCell: {
		'& p': {
			lineHeight: theme.direction === 'rtl' ? 1 : 'normal',
		},
	},
	departmentName: {
		display: 'flex',
		'& p': {
			margin: 'auto 0 auto 8px',
		},
	},
	editIcon: {
		color: primaryColor[0],
		margin: '0 3px 0 0',
	},
	departmentIcon: {
		width: 32,
		height: 32,
		borderRadius: 4,
		padding: 10,
		color: whiteColor,
	},
	login: {
		'& p': {
			lineHeight: theme.direction === 'rtl' ? 1 : 'normal',
		},
		...icon,
	},
	cellCaption: {
		margin: '5px 6px 0 6px',
	},
	topup: {
		paddingTop: 5,
	},
	userCaption: {
		marginLeft: 24,
	},
	departmentBadge: {
		marginTop: theme.direction === 'rtl' ? 0 : 3,
	},
	editButtons: {
		display: 'flex',
		'& > div': {
			flex: 1,
		},
	},
	wrapper: {
		textAlign: 'center',
	},
	icon: {
		marginBottom: 56,
	},
	addNumbersButton: {
		marginTop: 56,
	},
	addNumbersDialog: {
		[theme.breakpoints.down('sm')]: {
			paddingLeft: 28,
			paddingRight: 28,
		},
		[theme.breakpoints.up('sm')]: {
			paddingLeft: 56,
			paddingRight: 56,
		},
		[theme.breakpoints.down('xs')]: {
			paddingLeft: 6,
			paddingRight: 6,
		},
	},
	filterBy: {
		padding: 0,
	},
	topupCard: {
		width: '100%',
		marginBottom: 24,
	},
	topupValueContainer: {
		display: 'flex',
		textAlign: 'center',
	},
	topupValue: {
		flex: 1,
		cursor: 'pointer',
		paddingTop: 8,
		paddingBottom: 7,
	},
	topupValueChecked: {
		backgroundColor: primaryColor[0],
	},
	customInput: {
		paddingTop: 0,
		margin: '0 0 0 auto',
		'& input': {
			...defaultFont,
			textAlign: 'right',
			fontSize: 18,
			lineHeight: '24px',
			padding: '10px 8px 6px',
		},
	},
	refreshValueIcon: {
		color: primaryColor[0],
		margin: 12,
		height: 16,
		width: 16,
		cursor: 'pointer',
	},
	customTopUpInput: {
		width: '60%',
	},
	editInput: {
		padding: '0 5px 16px 16px',
	},
	marginValue: {
		marginTop: theme.direction === 'rtl' ? 12 : 18,
	},
	totalAmountValue: {
		...defaultFont,
		fontSize: 17,
		lineHeight: '24px',
		fontWeight: 'bold',
	},
	totalAmountCurrency: {
		...defaultFont,
		fontSize: 12,
		lineHeight: '24px',
		fontWeight: 'bold',
	},
	alignRight: {
		textAlign: 'right',
	},
	topupButton: {
		marginBottom: 'auto',
		marginTop: 'auto',
	},
	topUpButtonContainer: {
		display: 'flex',
	},
	headerContainer: {
		[theme.breakpoints.down('sm')]: {
			'& > div': {
				marginTop: 15,
			},
			'& > div:first-child': {
				marginTop: 0,
			},
			'& div:first-child': {
				textAlign: 'center',
			},
		},
	},
	selectedRow: {
		background: `linear-gradient(${blackColors[6]}, ${blackColors[6]}), linear-gradient(white, white)`,
	},
	editedRow: {
		background: `linear-gradient(rgba(${hexToRgb(primaryColor[0])}, 0.06), rgba(${hexToRgb(
			primaryColor[0]
		)}, 0.06)), linear-gradient(white, white)`,
	},
	accountPicker: {
		marginTop: 8,
		paddingTop: 9,
		marginBottom: 24,
		backgroundColor: whiteColor,
		'& .MuiInputBase-root': {
			paddingLeft: 17,
		},
		maxWidth: '50%',
	},
});

export default additionalInfoStyle;
